import { useTranslation } from 'react-i18next';
import { OverheadFeeScheduleDtoOut, OverheadFeeGroup } from '@/models/out/OverheadFeeScheduleDtoOut';
import styles from './OverheadFeeTables.module.css';

const GROUPS: OverheadFeeGroup[] = ['Donations', 'FundActions'];

interface OverheadFeeTablesProps {
  schedule: OverheadFeeScheduleDtoOut;
}

/**
 * The overheads as two tables: what is taken from donations, and what is charged for actions in the
 * fund. One component for every place that shows them - «אישורים ומסמכים» (HAT-1231) and the window
 * on the transactions board (HAT-1493) - so the two cannot drift apart, as the rows themselves and
 * the PDF already cannot: all of them come from the server's one schedule.
 *
 * The two groups sit side by side on a wide screen: seventeen rows in one column were half a page
 * of table.
 */
const OverheadFeeTables = ({ schedule }: OverheadFeeTablesProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.twoColumns}>
      {GROUPS.map((group) => {
        const rows = schedule.rows.filter((row) => row.group === group);
        if (rows.length === 0) return null;

        return (
          <div key={group} className={styles.column}>
            <h3 className={styles.groupTitle}>{t(`fundSettingsDocumentsPage.overheadGroups.${group}`)}</h3>
            <div className={styles.tableWrap}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    {/* The same column titles the document prints: «סוג התרומה» for the
                        donations, «פעולה» for what is done in the fund. */}
                    <th>{t(`fundSettingsDocumentsPage.overheadGroupColumns.${group}`)}</th>
                    <th>{t('fundSettingsInfoPage.overheadColumnFee')}</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => (
                    <tr key={row.action}>
                      <td>{row.action}</td>
                      <td className={styles.feeCell}>{row.fee}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default OverheadFeeTables;
